import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';
import { useTheme } from '@mui/material/styles'; // Import the theme hook
import PropTypes from 'prop-types'; // Import PropTypes

const DonutChart = ({ data }) => {
    const chartRef = useRef(null);
    const theme = useTheme(); // Access the theme
    const principalAmount = parseFloat(data.principalAmount) || 0;
    const interestAmount = parseFloat(data.interestAmount) || 0;

    useEffect(() => {
        const totalAmount = principalAmount + interestAmount;

        const principalAmountPercentage = ((principalAmount / totalAmount) * 100).toFixed(2);
        const interestAmountPercentage = ((interestAmount / totalAmount) * 100).toFixed(2);

        const options = {
            chart: {
                type: 'donut',
                height: 800,
                width: 400,
                redrawOnParentResize: true,
            },
            series: [interestAmount, principalAmount],
            labels: [
                `Interest Amount: (${interestAmountPercentage}%)`,
                `Principal Amount: (${principalAmountPercentage}%)`,
            ],
            colors: ['#9B134A', 'rgb(185, 80, 71)'],
            dataLabels: {
                enabled: false,
                style: {
                    colors: ['white'], // Use theme text color for labels
                    fontSize: '14px',
                },
            },
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (val, { seriesIndex }) {
                        return `${val}`;
                    },
                    title: {
                        formatter: function (seriesName) {
                            return seriesName;
                        },
                    },
                },
            },
            legend: {
                labels: {
                    colors: [theme.palette.text.primary], // Use theme text color for legend labels
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'top',
                            labels: {
                                colors: [theme.palette.text.primary], // Use theme text color for legend in small screens
                            },
                        },
                    },
                },
            ],
        };

        const chart = new ApexCharts(chartRef.current, options);
        chart.render();

          // Explicitly override ApexCharts' inline styles after rendering
          const overrideLabelColors = () => {
            const labels = chartRef.current.querySelectorAll('.apexcharts-legend-text');
            labels.forEach((label) => {
                label.style.color = theme.palette.text.primary; // Force the label color to match the theme
            });
        };

        // Call the override function after rendering
        overrideLabelColors();
        return () => {
            chart.destroy();
        };
    }, [interestAmount, principalAmount, theme]); // Add theme as a dependency

    return <div ref={chartRef} className="changeGraph" />;
};

  // PropTypes validation
  DonutChart.propTypes = {
        data: PropTypes.shape({
            principalAmount: PropTypes.number,
            interestAmount: PropTypes.number,
        }).isRequired,
    };
export default DonutChart;